import { render, staticRenderFns } from "./AccordionPage.vue?vue&type=template&id=966103bc&"
import script from "./AccordionPage.vue?vue&type=script&lang=js&"
export * from "./AccordionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports